import { render, staticRenderFns } from "./examen.vue?vue&type=template&id=5b74b082&"
import script from "./examen.vue?vue&type=script&lang=js&"
export * from "./examen.vue?vue&type=script&lang=js&"
import style0 from "./examen.vue?vue&type=style&index=0&id=5b74b082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports